import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Link from '../../../Link';
import Box from '../../../../shared/Box';
import Hoverable from '../../../../shared/Hoverable';
import { Caret } from '../../../../shared/Caret';
import IconBadge from '../../../IconBadge';
import { clickNavLink } from '../../events';

import styles from './styles.sass';
import LinkStyles from '../../LinkStyles.sass';

const cx = classnames.bind(LinkStyles);

const NavLinks = ({ links, pathname }) => (
  <ul className={styles.navLinksList}>
    {links.map(link => {
      const {
        label,
        key,
        to,
        subLinks,
        isShowingNotificationBadge,
        notificationBadge,
      } = link;
      return (
        <li key={key} className={styles.linkItem}>
          {!subLinks ? (
            <Link
              to={to}
              onClick={() => clickNavLink({ link: key })}
              className={cx({ link: true, linkActive: pathname === to })}
            >
              <span>
                {label}
                {isShowingNotificationBadge && (
                  <Box
                    position="absolute"
                    top
                    right
                    marginTop={0}
                    marginRight={-10}
                  >
                    <IconBadge
                      backgroundColor="green"
                      iconColor="#292F36"
                      width={10}
                      padding={1}
                      type={notificationBadge}
                    />
                  </Box>
                )}
              </span>
            </Link>
          ) : (
            <span
              tabIndex={0}
              className={`withSubLinks ${cx({
                link: true,
                linkActive: pathname === to,
              })}`}
            >
              {label} {subLinks && <Caret className={LinkStyles.caret} />}
            </span>
          )}
          {subLinks && (
            <ul className={`subLinks ${styles.subLinks}`}>
              {subLinks.map(subLink => (
                <li className={styles.subLinkItem} key={subLink.label}>
                  <Link to={subLink.to} className={`${styles.subLink}`}>
                    <span className={styles.subLinkContainer}>
                      {subLink.svg}
                      {subLink.label}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    })}
  </ul>
);

NavLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
      to: PropTypes.string,
      subLinks: PropTypes.arrayOf(
        PropTypes.shape({
          to: PropTypes.string,
          label: PropTypes.string,
          svg: PropTypes.element,
        })
      ),
      isShowingNotificationBadge: PropTypes.bool,
      notificationBadge: PropTypes.string,
    })
  ).isRequired,
  pathname: PropTypes.string.isRequired,
};

export { NavLinks };
